export const DEFAULT_LOADER = 'DEFAULT_LOADER'
export const OPTIMIZE_CREATING_REPORT_LOADER = 'OPTIMIZE_CREATING_REPORT_LOADER'
export const LABELS_CREATING_LOADER = 'LABELS_CREATING_LOADER'
export const LABELS_DOWNLOAD_LOADER = 'LABELS_DOWNLOAD_LOADER'
